export function xyToIndex(pos: XY): number {
	return pos[0] * 5 + pos[1];
}
